<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>        
        <v-flex lg12 v-if="storeVNRole">
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.TransactionCode }}</td>
                            <td>{{ (item.PackageType === 1 ? 'KG' : (item.LineType == 'chinh_ngach' ? 'CN' :
                                    'MD')) + item.OrderID }}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.BigPackageCode }}</td>
                            <td>{{ item.SessionCode }}</td>
                            <td>{{ item.StoreVNImportDate | display_date }}</td>
                            <td>{{ item.StoreVNExportDate | display_date }}</td>
                            <td class="text-right">{{ item.ProductNumber | currency }}</td>
                            <td class="text-right" v-if="weightEditable">
                                <v-edit-dialog :return-value.sync="item.Weight" large lazy @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                    <div>{{ item.Weight }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>{{ item.Weight | currency('', 1) }}</td>
                            <td class="text-right" v-if="weightEditable">
                                <v-edit-dialog large lazy @save="saveItem({ID: item.ID, Length: item.Length, Width: item.Width, Height: item.Height})">
                                <div>
                                    {{ item.Volume | currency('', 3) }}
                                    <v-divider></v-divider>
                                    {{ (item.Length | 0) + ' x ' + (item.Width | 0) + ' x ' + (item.Height | 0) }}
                                </div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Length" type="number" step="1" label="Dài (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Width" type="number" step="1" label="Rộng (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Height" type="number" step="1" label="Cao (cm)" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>{{ item.Volume | currency('', 3) }}</td>
                            <td class="text-right">{{ item.WeightByVolume | currency('', 1) }}</td>
                            <td>
                                <v-edit-dialog :return-value.sync="item.Status" large lazy @save="saveItem({ID: item.ID, Status: item.Status})">
                                    <div v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</div>
                                    <template v-slot:input>
                                        <v-select dense :items="package_status" v-model="item.Status" item-text="name" item-value="value"></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-tooltip top max-width="250">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.StoreVNNote }}</span>
                                    </template>
                                    <span>{{ item.StoreVNNote }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-center">
                                <v-icon :disabled="!item.UID" medium class="mr-2" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-flex lg12 v-else-if="storeTQRole">
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.TransactionCode }}</td>
                            <td>{{ (item.PackageType === 1 ? 'KG' : (item.LineType == 'chinh_ngach' ? 'CN' :
                                    'MD')) + item.OrderID }}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.BigPackageCode }}</td>
                            <td>{{ item.SessionCode }}</td>
                            <td class="text-right">{{ item.ProductNumber | currency }}</td>
                            <td class="text-right">
                                <v-edit-dialog :return-value.sync="item.Weight" large lazy @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                <div>{{ item.Weight | currency('', 1) }}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right">
                                <v-edit-dialog large lazy @save="saveItem({ID: item.ID, Length: item.Length, Width: item.Width, Height: item.Height})">
                                <div>
                                    {{ item.Volume | currency('', 3) }}
                                    <v-divider></v-divider>
                                    {{ (item.Length | 0) + ' x ' + (item.Width | 0) + ' x ' + (item.Height | 0) }}
                                </div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Length" type="number" step="1" label="Dài (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Width" type="number" step="1" label="Rộng (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Height" type="number" step="1" label="Cao (cm)" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td>{{ item.StoreCNImportDate | display_date }}</td>
                            <td>{{ item.ExDate | display_date }}</td>
                            <td>{{ item.StoreVNImportDate | display_date }}</td>
                            <td class="text-right">{{ item.FeeShip | currency('', 2) }}</td>
                            <td class="text-right">{{ item.FeeFragileGoods | currency('', 2) }}</td>
                            <td class="text-right">{{ item.FeeOther | currency('', 2) }}</td>
                            <td>
                                <v-edit-dialog :return-value.sync="item.Status" large lazy @save="saveItem({ID: item.ID, Status: item.Status})">
                                    <div v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</div>
                                    <template v-slot:input>
                                        <v-select dense :items="package_status" v-model="item.Status" item-text="name" item-value="value"></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-tooltip top max-width="250">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.StoreCNNote }}</span>
                                    </template>
                                    <span>{{ item.StoreCNNote }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-center">
                                <v-icon :disabled="!item.UID" medium class="mr-2" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-flex lg12 v-else>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.TransactionCode }}</td>
                            <td>{{ item.OrderCodeCN }}</td>
                            <td v-if="(moduleRole & 4096) && item.OrderID > 0"><a href="javascript: void(0)" @click="gotoDetail(item.PackageType, item.OrderID, item.UID)">{{ (item.PackageType === 1 ? 'KG' : (item.LineType == 'chinh_ngach' ? 'CN' :
                                    'MD')) + item.OrderID }}</a></td>
                            <td v-else>{{ (item.PackageType === 1 ? 'KG' : (item.LineType == 'chinh_ngach' ? 'CN' :
                                    'MD')) + item.OrderID }}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.BigPackageCode }}</td>
                            <td>{{ item.SessionCode }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td>{{ item.StoreCNImportDate | display_date }}</td>
                            <td>{{ item.ExDate | display_date }}</td>
                            <td>{{ item.StoreVNImportDate | display_date }}</td>
                            <td>{{ item.StoreVNExportDate | display_date }}</td>
                            <td class="text-right">{{ item.FeeShip | currency('', 2) }}</td>
                            <td class="text-right">{{ item.FeeFragileGoods | currency('', 2) }}</td>
                            <td class="text-right">{{ item.FeeOther | currency('', 2) }}</td>
                            <td class="text-right">{{ item.ProductNumber | currency }}</td>
                            <td class="text-right" v-if="weightEditable">
                                <v-edit-dialog :return-value.sync="item.Weight" large lazy @save="saveItem({ID: item.ID, Weight: item.Weight})">
                                <div>{{ item.Weight }}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>{{ item.Weight }}</td>
                            <td class="text-right" v-if="weightEditable">
                                <v-edit-dialog large lazy @save="saveItem({ID: item.ID, Length: item.Length, Width: item.Width, Height: item.Height})">
                                <div>
                                    {{ item.Volume | currency('', 3) }}
                                    <v-divider></v-divider>
                                    {{ (item.Length | 0) + ' x ' + (item.Width | 0) + ' x ' + (item.Height | 0) }}
                                </div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Length" type="number" step="1" label="Dài (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Width" type="number" step="1" label="Rộng (cm)" single-line autofocus></v-text-field>
                                    <v-text-field v-model="item.Height" type="number" step="1" label="Cao (cm)" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-else>{{ item.Volume | currency('', 3) }}</td>
                            <td class="text-right">{{ item.WeightByVolume | currency('', 1) }}</td>
                            <td>
                                <v-edit-dialog :return-value.sync="item.Status" large lazy @save="saveItem({ID: item.ID, Status: item.Status})">
                                    <div v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</div>
                                    <template v-slot:input>
                                        <v-select dense :items="package_status" v-model="item.Status" item-text="name" item-value="value"></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-edit-dialog :return-value.sync="item.OrderNote" large lazy @save="saveItem({ID: item.ID, OrderNote: item.OrderNote})">
                                <div>{{ item.OrderNote }}</div>
                                <template v-slot:input>
                                    <v-textarea rows="3" v-model="item.OrderNote" label="Ghi chú" single-line autofocus></v-textarea>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-center">
                                <v-icon v-if="show_quick_import_option && warehousing" medium class="ma-1" @click="doWarehousing(item.TransactionCode)">fa-boxes</v-icon>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" v-if="adminRoles" medium class="ma-1" color="gray darken-2" @click="saveItem({ID: item.ID, FakePrintDate: '[null]', FakeCustomerName: '[null]', FakeCustomerAddress: '[null]', FakeCustomerPhone: '[null]'})">fa-user-slash</v-icon>
                                    </template>
                                    <span>Xóa thông tin in tem</span>
                                </v-tooltip>                                
                                <v-icon :disabled="!item.UID" medium class="ma-1" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogExport" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Xuất file in tem</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-select :items="packages" v-model="selectedBigPackageID" item-text="PackageCode" item-value="ID"></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogExport = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="exportBigPackage">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExportVHK" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Xuất file vận hành kho</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <div>Ngày xuất kho TQ</div>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Từ ngày" v-model="export_options.start_date" :rules="date_validation"></v-text-field>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Đến ngày" v-model="export_options.end_date" :rules="date_validation"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogExportVHK = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="exportExcelVHK">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';
import _ from "lodash";
import moment from "moment";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            show_quick_import_option: configs.SYSTEM_CONFIG.quick_store_import,
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogExport: false,
            dialogExportVHK: false,
            selectedBigPackageID: 0,
            export_options: {
                start_date: moment.utc(Date.now()).subtract(1, 'days').format(configs.SHORT_DATE_FORMAT),
                end_date: moment.utc(Date.now()).format(configs.SHORT_DATE_FORMAT)
            },
            date_validation: [v => v.match(/^(0?[1-9]|[12][0-9]|3[01])[\-](0?[1-9]|1[012])[\-]\d{4}$/) || "DD-MM-YYYY"]
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
            packages: state => state.bigPackage.all.data
        }),
        headers() {
            if (this.storeTQRole) {
                return [
                    {
                        text: "Mã vận đơn",
                        value: "TransactionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "OrderID",
                        value: "OrderID",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khách hàng",
                        value: "Username",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã bao hàng",
                        value: "BigPackageCode",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Phiên lv",
                        value: "SessionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Số SP",
                        value: "ProductNumber",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân nặng",
                        value: "Weight",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khối",
                        value: "Volume",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Nhập kho TQ",
                        value: "StoreCNImportDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Xuất kho TQ",
                        value: "ExDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Nhập kho VN",
                        value: "StoreVNImportDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Phí ship",
                        value: "FeeShip",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Phí gia cố",
                        value: "FeeFragileGoods",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Phí khác",
                        value: "FeeOther",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: configs.PACKAGE_STATUS,
                        width: "140px"
                    },
                    {
                        text: "Ghi chú",
                        value: "StoreCNNote",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Thao tác",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ];
            }
            if (this.storeVNRole) {
                return [
                    {
                        text: "Mã vận đơn",
                        value: "TransactionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "OrderID",
                        value: "OrderID",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khách hàng",
                        value: "Username",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã bao hàng",
                        value: "BigPackageCode",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Phiên lv",
                        value: "SessionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Nhập kho VN",
                        value: "StoreVNImportDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Xuất kho VN",
                        value: "StoreVNExportDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Số SP",
                        value: "ProductNumber",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân nặng",
                        value: "Weight",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khối",
                        value: "Volume",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân quy đổi",
                        value: "WeightByVolume",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: configs.PACKAGE_STATUS,
                        width: "140px"
                    },
                    {
                        text: "Ghi chú",
                        value: "StoreVNNote",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Thao tác",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ];
            }
            return [
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã đơn CN",
                    value: "OrderCodeCN",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "OrderID",
                    value: "OrderID",
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã bao hàng",
                    value: "BigPackageCode",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Phiên lv",
                    value: "SessionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Nhập kho TQ",
                    value: "StoreCNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Xuất kho TQ",
                    value: "ExDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Nhập kho VN",
                    value: "StoreVNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Xuất kho VN",
                    value: "StoreVNExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Phí ship",
                    value: "FeeShip",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí gia cố",
                    value: "FeeFragileGoods",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí khác",
                    value: "FeeOther",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số SP",
                    value: "ProductNumber",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khối",
                    value: "Volume",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân quy đổi",
                    value: "WeightByVolume",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.PACKAGE_STATUS,
                    width: "140px"
                },
                {
                    text: "Ghi chú",
                    value: "OrderNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ];
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        storeVNRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);
        },
        storeTQRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ);
        },
        weightEditable() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
        },
        warehousing() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ);
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        printTransaction(id, package_type) {
            request_detail('order_transactions/print', ret => {
                let item = ret.data;
                print_transaction_v2(item);
            }, Vue.http, id, this.$store.state.authentication.token, {'PackageType': package_type});
        },
        saveItem:_.debounce(
        function(data) {
            if(data.Length > 0) {
                let item = _.find(this.items, {ID: data.ID})
                if(item) {
                    item.Volume = Math.round(data.Length * data.Width * data.Height / 100000)/10
                }
            }
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        // Only admin can view table, staff need search by code
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("orderTransaction/getList", param);
            this.$store.dispatch("bigPackage/getList");
        },
        doWarehousing(tran_code) {
            this.$store.dispatch("storeManager/setDetail", {
                data: {'TransactionCode': tran_code},
                id: 0
            });
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openDiaglogExport() {
            this.dialogExport = true;
        },
        exportBigPackage() {
            let item = _.find(this.packages, {ID: this.selectedBigPackageID});
            this.$store.dispatch("orderTransaction/export_bigpackage", {'BigPackageID': item.ID, 'PackageCode': item.PackageCode});
            this.dialogExport = false;
        },
        openDiaglogExportVHK() {
            this.dialogExportVHK = true;
        },
        exportExcelVHK() {
            this.$store.dispatch("orderTransaction/export_vhk", {'start_time': this.export_options.start_date, 'end_time': this.export_options.end_date});
            this.dialogExportVHK = false;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_CREATE_DATA", this.openDiaglogExport);
        this.$root.$on("REQUEST_SAVE_DATA", this.openDiaglogExportVHK);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.openDiaglogExport);
        this.$root.$off("REQUEST_SAVE_DATA", this.openDiaglogExportVHK);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
